import { PromoBanner } from "@/components/marketplace"
import type { PromoBannerSection } from "@/features/feed/contract"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const PromoBannerFeedSection = ({ section, context }: FeedSectionProps<PromoBannerSection>) => {
  const { title, sub, endsAt, cta } = section.data
  return (
    <SectionFrame section={section} context={context} gut>
      <PromoBanner title={title} sub={sub} endsAt={endsAt} cta={cta?.label} ctaHref={cta ? resolveFeedLink(cta.link, context.countryCode, context.page) : undefined} />
    </SectionFrame>
  )
}
